import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import { withFormik } from 'formik'
import * as yup from 'yup'

import { message, Form, Input, Button } from 'antd'

import { UPDATE_USER_PROFILE } from '../../../../graphql/mutations'

import Avatar from '../Avatar'

const validationSchema = () =>
  yup.object().shape({
    username: yup.string().required(),
    email: yup
      .string()
      .email()
      .required(),
    password: yup
      .string()
      .when('id', (id, passSchema) => (id ? passSchema : passSchema.required()))
  })

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { UpdateUser, data } = props

  setSubmitting(true)

  try {
    const result = await UpdateUser({
      variables: values
    })

    message.info(`User "${result.data.updateUser.name}" update successful`)
    data.refetch()
  } catch (error) {
    message.error(error.message)
  }

  setSubmitting(false)
}

export const ProfileForm = ({
  values,
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  dirty,
  isSubmitting
}) => (
  <Form layout="vertical" onSubmit={handleSubmit}>
    <Avatar src={values.avatar} size={128} />
    <Form.Item
      label="User Name"
      help={touched.username && errors.username ? errors.username : ''}
      validateStatus={touched.username && errors.username ? 'error' : undefined}
    >
      <Input
        name="username"
        placeholder="User Name"
        value={values.username}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </Form.Item>
    <Form.Item
      label="Email"
      help={touched.email && errors.email ? errors.email : ''}
      validateStatus={touched.email && errors.email ? 'error' : undefined}
    >
      <Input
        name="email"
        placeholder="Email"
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </Form.Item>

    <Form.Item style={{ textAlign: 'center' }}>
      <Button
        type="primary"
        htmlType="submit"
        disabled={!dirty || isSubmitting}
      >
        Update
      </Button>
    </Form.Item>
  </Form>
)

ProfileForm.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  dirty: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}

export default compose(
  graphql(UPDATE_USER_PROFILE, { name: 'UpdateUser' }),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ data: { me } }) => ({
      id: me && me.id,
      username: (me && me.username) || '',
      email: (me && me.email) || ''
    }),
    handleSubmit,
    validationSchema,
    displayName: 'AccountForm'
  })
)(ProfileForm)



// WEBPACK FOOTER //
// ./src/pages/Account/components/ProfileForm/index.js